import { Flex } from "antd"
import { useTranslation } from "react-i18next"

import Filters from "../../../../Components/Filters"
import { receiptColumnIconMap } from "../ReceiptLookupTable/columns"

// §BLOCK 4.2 — filter bar (Date, Card, Amount, Program, Fee charged) + Export праворуч.
const FilterBar = ({
  visibleFilters,
  filters,
  onChangeFilter,
  onClearFilters,
  isFiltersDefault,
  isMobile,
  rightSlot
}) => {
  const { t } = useTranslation()

  const programOptions = [
    { id: "cc", name: t("Consumer Clarity") },
    { id: "oi", name: t("Order Insight") }
  ]

  // §BLOCK 4.2 — Channel: Banking app / Call center / Mastercom (CHA1-1348).
  const channelOptions = [
    { id: "banking_app", name: t("Banking app") },
    { id: "call_center", name: t("Call center") },
    { id: "mastercom", name: t("Mastercom") }
  ]

  const filterOptions = {
    program: programOptions,
    channel: channelOptions
  }

  // "allFilters" очікує масив у форматі колонок — для receipt це фіксовані 6 фільтрів.
  const allFilters = [
    { field_id: "date", label: t("Date") },
    { field_id: "card", label: t("Card") },
    { field_id: "amount", label: t("Amount") },
    { field_id: "program", label: t("Program") },
    { field_id: "channel", label: t("Channel") },
    { field_id: "fee_charged", label: t("Fee charged") }
  ]

  return (
    <Flex
      gap={isMobile ? 0 : 32}
      align="center"
      justify="space-between"
      style={{ margin: "-4px 0 0", minWidth: 0 }}
    >
      <Filters
        filtersType="receipt"
        visibleFilters={visibleFilters}
        filterOptions={filterOptions}
        allFilters={allFilters}
        filters={filters}
        onChangeFilter={onChangeFilter}
        showClearBtn={!isFiltersDefault}
        onClearFilters={onClearFilters}
        columnIconMap={receiptColumnIconMap}
        isMobile={isMobile}
      />
      {rightSlot && <Flex style={{ flexShrink: 0 }}>{rightSlot}</Flex>}
    </Flex>
  )
}

export default FilterBar
